"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaasEvents = void 0;
var MaasEvents;
(function (MaasEvents) {
    MaasEvents["DA_ACCOUNTS_CONFIRMED"] = "da_accounts_confirmed";
    MaasEvents["DA_ENROLL_PAGELOAD"] = "da_enroll_pageload";
    MaasEvents["DA_POST_CONVERSION_EXPERIMENT"] = "da_post_conversion_experiment";
    MaasEvents["DA_NEXT_STEPS"] = "da_next_steps";
    MaasEvents["DA_ENROLLMENT_PATH_CHOICE"] = "enrollment_path_choice";
    MaasEvents["DAP_YPA"] = "dap_ypa";
})(MaasEvents = exports.MaasEvents || (exports.MaasEvents = {}));
